import * as css from './fullDescriptionStep.css';
import Btn from '../../../../component/button/btn/Btn';
import {useTranslation} from 'react-i18next';
import {getDescriptionFromGPT} from '../../../../redux/event/eventActions';
import {useFormikContext} from 'formik';
import {useSelector} from 'react-redux';
import {getArtistsByText} from '../titleStep/TitleStep';
import useTimeout from '../../../../hooks/useTimeout';
import StepRight from '../stepRight/StepRight';
import StepContext from '../stepContext/StepContext';
import StepLeft from '../StepLeft/StepLeft';
import { TState } from '../../../../redux/store.type';
import TextareaInput from '../../../../component/input/textareaInput/TextareaInput';
import { TEvent } from '../../../../redux/event/event.type';
import {useEffect} from 'react';

//TODO: implement textEditor with media upload
function FullDescriptionStep() {

    const form = useFormikContext() as {values: TEvent, getFieldHelpers: (name: string) => {setValue: (value: string) => void}};
    const xhr=useSelector((s:TState)=>s.event.getDescriptionFromGPTXHR);
    const {t} = useTranslation('newEvent');
    const event = useSelector((s:TState)=>s.event);
    const fullDescription=form.values.fullDescription;
    const timeout=useTimeout();

    useEffect(() => {
        if (!form.values.fullDescription && event.title) {
            getDescriptionFromGPT({eventName:event.title, eventType:event.type, eventLocation:event?.location,category:event?.category, artists:event?.artists})
                .then(res=>{
                    const {setValue} = form.getFieldHelpers('fullDescription');
                    setValue(res);
                })
                .catch(()=>{});
        }
    }, []);

    const onKeyDown=e=>{
        if(e.key==='Enter')
            e.stopPropagation();
    };
    const TextMe=(()=>{
        !form.values.fullDescription && getDescriptionFromGPT({eventName:event.title, eventType:event.type, eventLocation:event?.location,category:event?.category, artists:event?.artists})
            .then(res=>{
                const {setValue} = form.getFieldHelpers('fullDescription');
                setValue(res);})
            .catch(()=>{});
    });
      
    const onKeyUp=()=>{
        clearTimeout(timeout.current);
        timeout.current=setTimeout(() => {
            getArtistsByText(fullDescription,form);    
        }, 1000);
    };
    return (
        <css.wrapAll>
            <StepContext>
                <StepRight name={'fullDescription'} >
                    <css.wrapper>
                        { (xhr==='LOADING'  || !fullDescription)&& 
                    <Btn
                        onClick={TextMe}
                        disabled={xhr==='LOADING'}
                    >
                        <css.icon />
                        {xhr==='LOADING'?t('xhrLoading'): t('makeMeText')}
                    </Btn>  
                        }
                        <css.Textarea onKeyDown={onKeyDown}>
                            <TextareaInput name={'fullDescription'} text={fullDescription ? '' : t('textDescription')} events={{ onKeyUp }} description={undefined} icon={undefined}/>
                        </css.Textarea>
                    </css.wrapper>
                </StepRight>
                <StepLeft name={'fullDescription'} children={undefined}/>
            </StepContext>     
        </css.wrapAll>
    );
}

export default FullDescriptionStep;
